import React from 'react';
import { getPsConsoleRefundUrl } from '../../utils/psConsole';

interface RefundIdLinkProps {
    stage: string;
    realm: string;
    refundId: string;
    className?: string;
    children?: React.ReactNode;
}

const RefundIdLink: React.FC<RefundIdLinkProps> = ({
    stage,
    realm,
    refundId,
    className,
    children,
}) => (
    <a
        href={getPsConsoleRefundUrl(stage, realm, refundId)}
        className={className}
        target="_blank"
        rel="noreferrer"
        title={refundId}
    >
        {children ?? refundId}
    </a>
);

export default RefundIdLink;
